import { EventRecord } from "@/sharedTypes";
import { baseApi } from "../baseApi";

const eventTag = "EventRecord";

export const eventApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getEvents: builder.query<any, Record<string, any> | void>({
      query: (params) => {
        const searchParams = new URLSearchParams();

        if (params) {
          const { filters, pagination } = params as any;

          if (filters) {
            Object.entries(filters).forEach(([key, value]) => {
              if (value !== undefined && value !== null && value !== "") {
                searchParams.append(key, String(value));
              }
            });
          }

          if (pagination) {
            Object.entries(pagination).forEach(([key, value]) => {
              if (value !== undefined && value !== null) {
                searchParams.append(key, String(value));
              }
            });
          }
        }

        const queryString = searchParams.toString();
        return `/gw/events${queryString ? `?${queryString}` : ""}`;
      },
      providesTags: [eventTag],
    }),
    createEvent: builder.mutation({
      query: (payload: EventRecord) => ({
        url: "/gw/events",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: [eventTag],
    }),
    updateEvent: builder.mutation({
      query: ({ id, ...payload }: EventRecord) => ({
        url: `/gw/events/${id}`,
        method: "PUT",
        body: payload,
      }),
      invalidatesTags: [eventTag],
    }),
    deleteEvent: builder.mutation({
      query: (id: number) => ({
        url: `/gw/events/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [eventTag],
    }),
  }),
});

export const {
  useGetEventsQuery,
  useCreateEventMutation,
  useUpdateEventMutation,
  useDeleteEventMutation,
} = eventApi;
